<template>
  <button class="h-14 w-full transition bg-green-500 hover:bg-green-600 disabled:bg-green-600 disabled:cursor-not-allowed text-white rounded-md shadow-lg uppercase tracking-wide" :disabled="loading">
    <span v-show="loading" class="flex justify-center items-center">
      <span class="OptimizeButton-uploadingDot block w-3 h-3 mx-1 bg-white rounded-full"></span>
      <span class="OptimizeButton-uploadingDot block w-3 h-3 mx-1 bg-white rounded-full"></span>
      <span class="OptimizeButton-uploadingDot block w-3 h-3 mx-1 bg-white rounded-full"></span>
    </span>
    <span v-show="!loading">Optimize!</span>
  </button>
</template>

<script>
export default {
  props: {
    loading: Boolean
  }
}
</script>

<style lang="postcss">
@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.OptimizeButton-uploadingDot {
  animation-name: fade;
  animation-direction: alternate;
  animation-duration: 750ms;
  animation-iteration-count: infinite;
}

.OptimizeButton-uploadingDot:nth-child(2) {
  animation-delay: 250ms;
}

.OptimizeButton-uploadingDot:last-child {
  animation-delay: 500ms;
}
</style>